// src/components/Logo.jsx
import React, { useId } from 'react';
import { Link } from 'react-router-dom';

const ShieldIcon = ({ size = 38 }) => {
  // unique IDs per instance to avoid gradient conflicts
  const uid = Math.random().toString(36).slice(2, 7);
  const gShield = `jt-sg-${uid}`;
  const gJ      = `jt-jg-${uid}`;
  const glow    = `jt-gl-${uid}`;

  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id={gShield} x1="20" y1="10" x2="80" y2="90">
          <stop offset="0%"   stopColor="#00FFE0" />
          <stop offset="60%"  stopColor="#00D4B8" />
          <stop offset="100%" stopColor="#00B89C" />
        </linearGradient>
        <linearGradient id={gJ} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#00FFE0" />
          <stop offset="100%" stopColor="#00C8AA" />
        </linearGradient>
        <filter id={glow} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="1.8" result="blur"/>
          <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
      </defs>

      {/* Navy background */}
      <rect width="100" height="100" rx="22" fill="#0A1628"/>

      {/* Shield glow layer */}
      <path d="M50 10 L18 24 L18 52 C18 70 50 88 50 88 C50 88 82 70 82 52 L82 24 Z"
        fill="none" stroke="#00E5CC" strokeWidth="3.5" strokeLinejoin="round"
        opacity="0.18" filter={`url(#${glow})`}/>

      {/* Shield main */}
      <path d="M50 10 L18 24 L18 52 C18 70 50 88 50 88 C50 88 82 70 82 52 L82 24 Z"
        fill="none" stroke={`url(#${gShield})`} strokeWidth="2.4" strokeLinejoin="round"/>

      {/* Inner ring */}
      <circle cx="50" cy="47" r="20" fill="none" stroke="#00D4B8" strokeWidth="1.4" opacity="0.3"/>

      {/* Tick marks */}
      <path d="M70 47 L73 47" stroke="#00E5CC" strokeWidth="1.2" opacity="0.55"/>
      <path d="M69 38.5 L71 36.5" stroke="#00E5CC" strokeWidth="1.2" opacity="0.45"/>

      {/* J */}
      <text x="50" y="59" textAnchor="middle"
        fontFamily="'SF Pro Display','Helvetica Neue',Arial,sans-serif"
        fontWeight="700" fontSize="30"
        fill={`url(#${gJ})`}
        filter={`url(#${glow})`}>J</text>
    </svg>
  );
};

export default function Logo({ iconSize = 36, badge, to = '/', noLink = false, iconOnly = false }) {
  const fontSize = Math.round(iconSize * 0.52);

  const content = (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
      <ShieldIcon size={iconSize} />
      {!iconOnly && (
        <span style={{ display: 'inline-flex', alignItems: 'baseline', gap: 5 }}>
          <span style={{ fontSize, fontWeight: 700, letterSpacing: '-0.5px', lineHeight: 1 }}>
            <span style={{ color: '#00E5CC' }}>Jep</span>
            <span style={{ color: '#22D97F' }}>Tags</span>
          </span>
          {badge && (
            <span style={{
              fontSize: Math.max(8, fontSize * 0.46),
              fontWeight: 700, letterSpacing: '2px',
              textTransform: 'uppercase',
              color: 'rgba(224,240,240,0.22)',
            }}>{badge}</span>
          )}
        </span>
      )}
    </span>
  );

  if (noLink) return <span style={{ display: 'inline-flex' }}>{content}</span>;
  return <Link to={to} style={{ textDecoration: 'none', display: 'inline-flex' }}>{content}</Link>;
}